module.exports = __webpack_public_path__ + "static/brain@2x-ec626b4f14c81a5a7a96bdf8e8f868ba.png";